/**
 * WordPress API helper
 * Using non-pretty permalinks fallback (?rest_route=) for maximum compatibility.
 */

const API_ROOT = '/index.php?rest_route=/wp/v2';

export const fetchFromWp = async (endpoint, params = {}) => {
    try {
        const query = new URLSearchParams(params).toString();
        // Since API_ROOT already has a ?, we append with &
        const url = `${API_ROOT}/${endpoint}${query ? `&${query}` : ''}`;
        
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`WP API Error: ${response.status} ${response.statusText}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error fetching from WordPress:', error);
        return null;
    }
};

export const getAboutPage = async () => {
    const pages = await fetchFromWp('pages', { slug: 'about', _embed: '1' });
    if (pages && pages.length > 0) {
        return pages[0];
    }
    return null;
};

export const getHomePage = async () => {
    const pages = await fetchFromWp('pages', { slug: 'home' });
    if (pages && pages.length > 0) {
        return pages[0];
    }
    return null;
};

export const getServices = async () => {
    return await fetchFromWp('service', { per_page: 20 });
};

export const getServiceBySlug = async (slug) => {
    const data = await fetchFromWp('service', { slug });
    if (data && data.length > 0) {
        return data[0];
    }
    return null;
};

export const getTestimonials = async () => {
    return await fetchFromWp('testimonial', { per_page: 20 });
};

export const getPortfolios = async () => {
    return await fetchFromWp('portfolio', { per_page: 20, _embed: '1' });
};

export const getPortfolioBySlug = async (slug) => {
    const data = await fetchFromWp('portfolio', { slug, _embed: '1' });
    if (data && data.length > 0) {
        return data[0];
    }
    return null;
};

export const getSettings = async () => {
    try {
        const response = await fetch('/index.php?rest_route=/digital-services/v1/settings');
        if (!response.ok) {
            throw new Error(`WP API Error: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching settings:', error);
        return null;
    }
};
